<form [formGroup]="formGroup">
  <h6 class="usage-information-filter-label">
    {{ 'usage.report.filter.info' | transloco }}
  </h6>
  <markant-select
    formControlName="servicePackageId"
    required="true"
    [label]="'usage.report.filter.form.servicePackage.label' | transloco"
    [options]="servicePackageOptions"
  >
  </markant-select>
  <markant-select
    formControlName="frequency"
    required="true"
    [label]="'usage.report.filter.form.interval.label' | transloco"
    [options]="frequencyOptions"
  >
  </markant-select>

  <markant-datepicker
    *ngIf="formGroup.controls['timePeriod'] as datepickerControl"
    formControlName="timePeriod"
    required="true"
    [dateFormat]="'common.datePicker.format.date' | transloco"
    [range]="true"
    [errorText]="
      datepickerControl.errors
        | formControlKeyError
          : 'usage.report.filter.form.timePeriod.error.blankOrInvalidRange'
          : datepickerControl.touched || datepickerControl.dirty
          : true
        | transloco
    "
    [label]="'usage.report.filter.form.timePeriod.label' | transloco"
    [useCustomLayout]="true"
  ></markant-datepicker>
</form>

<markant-checkbox
  [small]="true"
  [checked]="isCurrentDeliveryPeriod"
  (checkedChange)="showCurrentTimePeriod($any($event).detail)"
  >{{ 'usage.report.filter.form.currentTimePeriod.label' | transloco }}
</markant-checkbox>
